<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<template>
  <div v-if="campaign">
    <campaign-details :data-campaign.sync="campaign" :data-default-campaign.sync="defaultCampaign" @update:dataCampaign="updateCampaign" />
  </div>
</template>

<script>
import CampaignDetails from "./detail";

export default {
  components: { CampaignDetails },
  props: {
    id: {
      required: true,
    },
  },
  data: () => ({
    campaign: null,
    defaultCampaign: null,
  }),
  mounted() {
    // eslint-disable-next-line arrow-parens
    this.$http.get(`/api/v1/campaigns/${this.id}`).then((campaign) => (this.campaign = campaign));
    this.$http
      .get(`/api/v1/getDefaultCampaign`)
      .then((defaultCampaign) => (this.defaultCampaign = defaultCampaign));
  },
  methods: {
    updateCampaign(campaign) {
      if (campaign) {
        this.campaign = campaign;
      }
    },
  },
};
</script>
